import { useDispatch, useSelector } from 'react-redux';
import DMSDropdown from '../../../../stepper/stepperBody/stepperBodyComponents/DMSSelectionComponents/DMSDropdown/DMSDropdown';
import { updateDMSAccounts } from '../../../../../redux/connectedComponent/updateDMSAccounts/updateDMSAccounts.slice';
import './DMSAccountsList.scss';

const { DMS_ACCOUNT_TYPES_MAPPING } = require('../../../../stepper/stepperBody/stepperBodyComponents/DMSSelectionComponents/utils/constant');

const DMSAccountsList = ({ solutionData, disableSave }) => {
  const dispatch = useDispatch();

  const {
    updatedDMSAcounts,
    mergedDMSAccounts
  } = useSelector(state => state.updateDMSAccountsSlice);
  const { entityIdAddressMapping } = useSelector(state => state.loginDetailsSlice);

  const apiDetails = solutionData?.registration_details?.api_details;

  const handleSelectDMS = (location, dmsAccount, departments, cmfNumber, dmsAccountType, entityId, type, id) => {
    dispatch(updateDMSAccounts({ location, dmsAccount, departments, cmfNumber, dmsAccountType, entityId, type, id }));
  };

  const getDMSAccountHeader = dmsType => {
    if (Object.entries(DMS_ACCOUNT_TYPES_MAPPING).filter(ele => ele[1] === dmsType).length) {
      return `${dmsType} DMS Account`;
    }
  }

  const getApiNamesForDmsType = (dmsAccountDetails, apiDetails) => {
    const apiIds = new Set();
    for (const { api } of dmsAccountDetails) {
      if (Array.isArray(api)) {
        api.forEach(id => apiIds.add(id));
      } else {
        apiIds.add(api);
      }
    }
    return [...apiIds]
      .map(id => apiDetails?.find(a => a.id === id)?.displayName)
      .join(', ');
  };

  const renderDealerships = dmsAccountDetails => {
      let filteredLocations = [...new Map(dmsAccountDetails.map(item => [item['entityId'], item])).values()];
      let filterLocationWithDMSAccounts = dmsAccountDetails.filter(location => location.dmsAccount);

      if (filterLocationWithDMSAccounts.length !== filteredLocations.length) {
        filteredLocations.forEach(item => {
          if (!filterLocationWithDMSAccounts.some(element => item.entityId === element.entityId)) {
            filterLocationWithDMSAccounts.push(item);
          }
        });
      }

      return filterLocationWithDMSAccounts.map(locationData => {
        let { location, dmsAccount, cmfNumber, dmsAccountType, departments, entityId, type, id } = locationData;
        let object = updatedDMSAcounts.find(item => {
          return (
            item.location === location &&
            item.entityId === entityId &&
            item.id === id &&
            item.type === type
          );
        });

        return (
          <DMSDropdown
            key={`${entityId}-${cmfNumber}-${dmsAccountType}-${id}`}
            location={location}
            address={entityIdAddressMapping[entityId]}
            cmfNumber={cmfNumber}
            dmsAccount={dmsAccount}
            dmsAccountType={dmsAccountType}
            departments={departments}
            entityId={entityId}
            handleSelectDMS={handleSelectDMS}
            id={id}
            selectedDMS={object && object.dmsAccount}
            selectedDepartments={object && object.departments}
            type={type}
            disableSave={disableSave}
          />
        );
      });
  };

  return (
    mergedDMSAccounts && Object.entries(mergedDMSAccounts).map(([dmsType, dmsAccountDetails]) => {
      return (
        <div className="select-dms-account-container" key={dmsType}>
          <div className="dms-header">
            <div className="dms-header-title">
              {getDMSAccountHeader(dmsType)}
            </div>
            <div className="dms-card-header-subtitle">
              {getApiNamesForDmsType(dmsAccountDetails, apiDetails)}
            </div>
          </div>
          {renderDealerships(dmsAccountDetails)}
        </div>
      );
    })
  )
};

export default DMSAccountsList;
